// extracted by mini-css-extract-plugin
export default {"option":"NSbo_3cptBP8v6c6ETXu","action":"wbHX1d9SlnxxpiZB76Rh","tagging":"HoipWongx0atTmraNX0a"};